import { render, staticRenderFns } from "./featuredPro.vue?vue&type=template&id=3ac6c644&"
import script from "./featuredPro.vue?vue&type=script&lang=js&"
export * from "./featuredPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports